import ShortAtcService from "../../../../../services/IpadPreview/BeforeTake-off/FlightPlanning/shortatc.service"

const state = {
    jsonDataOfpTxt: [],
    jsonDataOfpFlight : [],
    samplevalue : "",
};
const mutations = {
    set_jsonOfpTxt_data(state, payload) {
        state.jsonDataOfpTxt = payload;
        state.samplevalue = "test";
    },
    set_jsonOfpFlight_data(state, payload) {
        state.jsonDataOfpFlight = payload;
        state.samplevalue = "test";
    }
};

const actions = {
    async getJsonDataOfpText({commit},{FKey1,TableCode}){
        const  jsonData = await  ShortAtcService.getJsonData(FKey1,TableCode);

        if (TableCode==="OFPFLIGHT")
        {
            //OFPFLIGHT
            await  commit("set_jsonOfpFlight_data",jsonData);

        }
        else if (TableCode==="OFPTXT")
        {
            await  commit("set_jsonOfpTxt_data",jsonData);
        }


        return  jsonData;
    },
};

const getters = {
    ParseAtcShortDataFromOfpTextData : state => {
        let list = [];
        for (let i = 0; i < state.jsonDataOfpTxt.length; i++) {
            if (state.jsonDataOfpTxt[i].LineCategory === "AtcShort") {
                list.push(state.jsonDataOfpTxt[i].LineContext);
            }
        }
        return list;

        },
    }

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
